module.exports = "/dog-racing/img/vdh-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/vdh-bck.png
// module id = 157
// module chunks = 8